import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import { AccountSalesHistoryResponse } from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';

type OrderHistoryResult = {
  success: boolean;
  data: AccountSalesHistoryResponse | null;
};

@Injectable({
  providedIn: 'root',
})
export class WholesaleOrderHistoryService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly orderHistoryApiUrl =
    this.environment.wholesale_order_history_api_url;

  public getOrderHistory(
    accountNumber: string,
  ): Observable<OrderHistoryResult> {
    return this.http
      .get<AccountSalesHistoryResponse>(
        `${this.orderHistoryApiUrl}/${accountNumber}`,
        { ...requireAppCheck },
      )
      .pipe(
        map((data) => ({
          success: true,
          data,
        })),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: null });
        }),
      );
  }
}
